import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import DeviceTransactionsReportSpinner from "../reports/Cachet/DeviceTransactionsReport/DeviceTransactionsReportSpinner";

const actions = {
  closeModal,
};

const deviceTransactionsReportSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <DeviceTransactionsReportSpinner />
    </TransparentModal>
  );
};

export default connect(
  null,
  actions
)(deviceTransactionsReportSpinnerModal);
